import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useViewMode } from '@/stores/viewMode'

interface TemplateApplicationStats {
  totalClinics: number
  totalDevices: number
  totalApplications: number
}

export function useAdScheduleTemplateStats() {
  const { token } = useAuth()
  const { mode, id: viewModeId } = useViewMode()
  const providerId = mode === 'provider' && viewModeId ? viewModeId : undefined
  const query = providerId ? `?providerId=${providerId}` : ''

  const { data, error, mutate } = useGet<ApiResponse<TemplateApplicationStats>>(
    token ? `/api/ad-schedule-templates/applications/stats${query}` : null,
    undefined,
    token ?? '',
  )

  return {
    stats: data?.data || null,
    totalClinics: data?.data?.totalClinics || 0,
    totalDevices: data?.data?.totalDevices || 0,
    totalApplications: data?.data?.totalApplications || 0,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
